import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import * as React from "react"

import { TickYes } from "../components"
import { cn } from "./util"

const CheckboxRoot = CheckboxPrimitive.Root
const CheckboxIndicator = CheckboxPrimitive.Indicator
const Checkbox = React.forwardRef<
    React.ElementRef<typeof CheckboxPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
    <CheckboxRoot
        ref={ref}
        className={cn(
            "border-primary focus-visible:ring-ring data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground peer h-4 w-4 shrink-0 rounded-sm border shadow focus-visible:outline-none focus-visible:ring-1 disabled:cursor-not-allowed disabled:opacity-50",
            className
        )}
        {...props}>
        <CheckboxIndicator className={cn("flex items-center justify-center text-current")}>
            <TickYes className="h-4 w-4" />
        </CheckboxIndicator>
    </CheckboxRoot>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox, CheckboxIndicator, CheckboxRoot }
